import { fontSize, theme } from "@tm/utility/global";
import styled from "styled-components";

import { SheetHeader as BaseSheetHeader } from "../sheet.style";

export {
  CloseButton,
  Overlay as Backdrop,
  SheetPanel,
  SheetTitle,
} from "../sheet.style";

export const SheetHeader = styled(BaseSheetHeader)`
  padding: 0 24px 16px;
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px;
`;

export const ReasonRow = styled.button<{ $disabled?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border: none;
  border-bottom: 1px solid ${theme.lightGrey};
  background: none;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  text-align: left;
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};

  &:last-child {
    border-bottom: none;
  }

  &:disabled {
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: -2px;
    border-radius: 4px;
  }
`;

export const ReasonTitle = styled.span<{ $disabled?: boolean }>`
  flex: 1;
  font-size: ${fontSize.font14};
  color: ${({ $disabled }) => ($disabled ? theme.greyText4 : theme.blackText)};
`;

export const ReasonSubtitle = styled.span`
  font-size: ${fontSize.font12};
  color: ${theme.greyText};
  margin-top: 2px;
`;

export const ReasonContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ChevronWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transform: rotate(90deg);
`;
